module.exports = __webpack_public_path__ + "img/apitab-color.ca2d9b7c.png";